import type { FC } from "react";

import { UnsubscribeBlock as UnsubscribeBlockUI } from "@jti/ui/components/UnsubscribeBlock";

import type { unsubscribeBlockInputs } from "./UnsubscribeBlock.builder";

export type UnsubscribeBlockProps = BuilderComponentProps<typeof unsubscribeBlockInputs>;

export const UnsubscribeBlock: FC<UnsubscribeBlockProps> = (props) => {
  return <UnsubscribeBlockUI successMessage={props.successMessage} errorMessage={props.errorMessage} />;
};
